// extracted by mini-css-extract-plugin
export var About = "style-module--About--1TOv9";
export var Description = "style-module--Description--1VGSg";
export var ImageWrapper = "style-module--ImageWrapper--3NjR-";
export var Image = "style-module--Image--2gKDM";